import React from 'react'
import { Route, IndexRoute, Redirect } from 'react-router'
import { routerActions } from 'react-router-redux'
import { UserAuthWrapper } from 'redux-auth-wrapper'

import MainContainer from './containers/main-container'
import Entry from './components/entry'

import LoginContainer from './containers/login/login-container'
import PrivacyAgreementContainer from './containers/privacy/privacy-agreement-container'
import AcceptTermsContainer from './containers/login/accept-terms-container'
import forgotPasswordContainer from './containers/login/forgot-password-container'
import forgotPasswordSuccessContainer from './containers/login/forgot-password-success-container'

import WorkOrdersContainer from './containers/work-orders/work-orders-container'
import WorkOrdersCreateContainer from './containers/work-orders/work-orders-create-container'
import WorkOrdersEditContainer from './containers/work-orders/work-orders-edit-container'
import WorkOrdersDetailsContainer from './containers/work-orders/work-orders-details-container'
import AreaCreateContainer from './containers/areas/area-create-container'
import AssignServicingContainer from './containers/servicings/assign-servicing-container'
import CreatePinContainer from './containers/pins/create-pin-container'
import UpdatePinContainer from './containers/pins/update-pin-container'
import PinDetailsContainer from './containers/pins/pin-details-container'
import TransferAreaModalContainer from './containers/work-orders/transfer-area-modal-container'

import ServicingDetailsContainer from './containers/servicings/servicing-details-container'
import ServicingLabelSelectContainer from './containers/servicing-labels/servicing-label-select-form-container'
import DailyWorkSheetSummary from './components/daily-work-sheet-summary'
import ConfirmServicingApprovalContainer from './containers/servicings/confirm-servicing-approval-container'
import OpenServicingRedoReasonFormContainer from './containers/servicings/open-servicing-redo-reason-form-container'
import RescheduledServicingRedoReasonFormContainer from './containers/servicings/rescheduled-servicing-redo-reason-form-container'
import ServicingImagesContainer from './containers/servicings/servicing-images-container'
import ServicingImagesFormContainer from './containers/servicings/servicing-images-form-container'
import ServicingRedoImagesContainer from './containers/servicings/servicing-redo-images-container'

import QAWorkOrdersContainer from './containers/qa-work-orders/qa-work-orders-container'
import QAWorkOrderCreateContainer from './containers/qa-work-orders/qa-work-order-create-container'
import QAWorkOrderDetailsContainer from './containers/qa-work-orders/qa-work-order-details-container'
import QAServicingDetailsContainer from './containers/qa-servicings/qa-servicing-details-container'
import QAServicingMultiCreateContainer from './containers/qa-servicings/qa-servicing-multi-create-container'

import WorkSummariesContainer from './containers/work-summaries/work-summaries-container'
import WorkSummaryDetailsContainer from './containers/work-summaries/work-summary-details-container'
import WorkSummarySignOffContainer from './containers/work-summaries/work-summary-sign-off-container'
import WorkSummaryAddServicesContainer from './containers/work-summaries/work-summary-add-services-container'

import WorkTrackersContainer from './containers/work-trackers/work-trackers-container'
import WorkTrackerDetailsContainer from './containers/work-trackers/work-tracker-details-container'
import WorkTrackerAreaDetailsContainer from './containers/areas/work-tracker-area-details-container'
import WorkTrackerContractFilterContainer from './containers/work-trackers/work-tracker-contract-filter-container'
import WorkTrackerAreaTypeFilterContainer from './containers/work-trackers/work-tracker-area-type-filter-container'
import WorkTrackerSubLocationFilterContainer from './containers/work-trackers/work-tracker-sub-location-filter-container'
import WorkTrackerDatePickerContainer from './containers/work-trackers/work-tracker-date-picker-container'
import WorkTrackerServiceFilterContainer from './containers/work-trackers/work-tracker-service-filter-container'
import WorkTrackerAmountFilterContainer from './containers/work-trackers/work-tracker-amount-filter-container'
import WorkTrackerSortingContainer from './containers/work-trackers/work-tracker-sorting-container'

import WorkTrackerServicingVersionsContainer from './containers/work-trackers/work-tracker-servicing-versions-container'

import MSDSSheetsContainer from './containers/msds-sheets/msds-sheets-container'

import LocationListContainer from './containers/issues/location-list-container'
import LocationIssuesListContainer from './containers/issues/location-issues-list-container'
import IssueDetailsContainer from './containers/issues/issue-details-container'
import IssueCreateContainer from './containers/issues/issue-create-container'
import IssueEditContainer from './containers/issues/issue-edit-container'
import IssueWorkOrderFormContainer from './containers/issues/issue-work-order-form-container'
import ServicingIssuesListContainer from './containers/issues/servicing-issues-list-container'
import AreaIssuesListContainer from './containers/issues/area-issues-list-container'

import InspectionLocationListContainer from './containers/inspections/location-list-container'
import LocationInspectionsListContainer from './containers/inspections/inspections-container'
import InspectionImagesContainer from './containers/inspections/inspection-images-container'

import SettingsContainer from './containers/settings/settings-container'

import CalendarContainer from './containers/calendar/calendar-container'
import ReportsContainer from './containers/reports/reports-container'

import NotFound from './components/not-found'

const userIsAuthenticated = UserAuthWrapper({
  authSelector: (state) => state.auth.session,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAuthenticated',
  allowRedirectBack: false,
  failureRedirectPath: (state) => {
    const session = state.auth.session

    if (!session) { return '/login' }
    if (session && !session.hasAcceptedTerms) { return '/accept-terms' }
  },
  predicate: (session) => session && session.hasAcceptedTerms
})

const userIsNotAuthenticated = UserAuthWrapper({
  authSelector: (state) => state.auth.session,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsNotAuthenticated',
  allowRedirectBack: false,
  failureRedirectPath: '/work-orders',
  predicate: (session) => !session
})

const hasNotAgreed = UserAuthWrapper({
  authSelector: (state) => state.auth.session,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'hasNotAgreed',
  failureRedirectPath: '/login',
  allowRedirectBack: false,
  predicate: (session) => session && !session.hasAcceptedTerms
})

export default (store) => (
  <Route>
    <Route component={userIsNotAuthenticated(Entry)}>
      <Route path='/login' component={LoginContainer}>
        <Route path='forgot-password' component={forgotPasswordContainer} />
        <Route path='forgot-password-success' component={forgotPasswordSuccessContainer} />
      </Route>
      <Route path='/privacy-policy' component={PrivacyAgreementContainer} />
    </Route>
    <Redirect from='/' to='work-orders' />
    <Route path='/accept-terms' component={hasNotAgreed(AcceptTermsContainer)} />
    <Route component={userIsAuthenticated(MainContainer)} name='mainContainer'>
      <Route path='work-orders' name='Work Orders'>
        <IndexRoute component={WorkOrdersContainer} />
        <Route path='create' component={WorkOrdersContainer} name='createWorkOrder'>
          <IndexRoute component={WorkOrdersCreateContainer} />
        </Route>
        <Route path=':workOrderId/details' name='Details'>
          <IndexRoute component={WorkOrdersDetailsContainer} />
          <Route path='edit' components={WorkOrdersEditContainer} name='editWorkOrder' />
          <Route path='areas/create' component={WorkOrdersDetailsContainer} name='addAreaWorkOrder'>
            <IndexRoute component={AreaCreateContainer} />
          </Route>
          <Route path='transfer-area/:areaId' component={WorkOrdersDetailsContainer}>
            <IndexRoute component={TransferAreaModalContainer} name='transferArea' />
          </Route>
          <Route path='areas/:areaId' staticName name='Area'>
            <IndexRoute component={ServicingDetailsContainer} />
            <Route path='transfer' component={ServicingDetailsContainer}>
              <IndexRoute component={TransferAreaModalContainer} name='transferArea' />
            </Route>

            <Route path=':servicingAreaId/issues' name='Issues' staticName>
              <IndexRoute component={AreaIssuesListContainer} />
            </Route>

            <Route path='labels' component={ServicingDetailsContainer} name='Labels'>
              <IndexRoute component={ServicingLabelSelectContainer} />
            </Route>

            <Route path='images' component={ServicingDetailsContainer} name='servicingImages'>
              <IndexRoute component={ServicingImagesFormContainer} />
            </Route>

            <Route path='pins/create' component={ServicingDetailsContainer} name='createPin'>
              <IndexRoute component={CreatePinContainer} />
            </Route>

            <Route path='assign' component={ServicingDetailsContainer} name='assignArea'>
              <IndexRoute component={AssignServicingContainer} />
            </Route>

            <Route path='pins/:pinId' staticName name='Pin'>
              <IndexRoute component={PinDetailsContainer} />

              <Route path='edit' component={PinDetailsContainer} name='updatePin'>
                <IndexRoute component={UpdatePinContainer} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>

      {[
        { path: 'in-progress', title: 'In Progress' },
        { path: 'summaries', title: 'Daily Work Sheet Summary' }
      ].map(route => (
      <Route path={route.path} name={route.title} key={route.path}>
        <IndexRoute component={WorkSummariesContainer} />

        <Route path=':workSummaryId' name='Details' getDisplayName={({ workSummaryId }) => {

          const { workOrders: { [workSummaryId]: { status = '' } = {} } = {} } = store.getState()

          return 'Details / ' + ((_status) => {
            switch(_status) {
              case 'signed_off': return 'Archive';
              case 'pending_approval': return 'Pending Approval';
              case 'in_progress': return 'In Progress';
              case 'open': return 'Open';
              default: return '';
            }
          })(status);
        }} >
          <IndexRoute component={WorkSummaryDetailsContainer} />

          <Route component={WorkSummaryDetailsContainer} path='sign-off'>
            <IndexRoute component={WorkSummarySignOffContainer} />
          </Route>

          <Route component={WorkSummaryDetailsContainer} path='add-services/:servicingId' name="Add Services" staticName>
            <IndexRoute component={WorkSummaryAddServicesContainer} />
          </Route>

          <Route path=":servicingId/issues" name="Issues">
            <IndexRoute component={ServicingIssuesListContainer} />
          </Route>

          <Route path=":servicingId/images" name="Images">
            <IndexRoute component={ServicingImagesContainer} />
          </Route>

          <Route path=":servicingId/redo_images" name="Inspection Images">
            <IndexRoute component={ServicingRedoImagesContainer} />
          </Route>

          <Route path="confirm/:servicingId" component={WorkSummaryDetailsContainer} name="Confirm Servicing" staticName>
            <IndexRoute component={ConfirmServicingApprovalContainer} />
          </Route>

          <Route path="open_redo_reason/:servicingId" component={WorkSummaryDetailsContainer} name="Confirm Servicing" staticName>
            <IndexRoute component={OpenServicingRedoReasonFormContainer} />
          </Route>

          <Route path="rescheduled_redo_reason/:servicingId" component={WorkSummaryDetailsContainer} name="Confirm Servicing" staticName>
            <IndexRoute component={RescheduledServicingRedoReasonFormContainer} />
          </Route>
        </Route>
      </Route>))}

      <Route path='calendar' name='Calendar'>
        <IndexRoute component={CalendarContainer} />
        <Route path='create-work-order' name='Create Work Order' component={WorkOrdersCreateContainer} />
      </Route>

      <Route path='reports' name='Reports'>
        <IndexRoute component={ReportsContainer} />
      </Route>

      <Route path='work-tracker' name='Work Tracker'>
        <IndexRoute component={WorkTrackersContainer} />

        <Route path=':locationId' name='Details' staticName>
          <IndexRoute component={WorkTrackerDetailsContainer} />

          <Route path='servicing-versions' component={WorkTrackerServicingVersionsContainer} name="Corrective Action">
            <IndexRoute component={WorkTrackerServicingVersionsContainer} />
          </Route>

          <Route path='filter-contract' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerContractFilterContainer} />
          </Route>

          <Route path='filter-room-type' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerAreaTypeFilterContainer} />
          </Route>

          <Route path='filter-sub-location' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerSubLocationFilterContainer} />
          </Route>

          <Route path='filter-date-period' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerDatePickerContainer} />
          </Route>

          <Route path='filter-service' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerServiceFilterContainer} />
          </Route>

          <Route path='filter-amount' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerAmountFilterContainer} />
          </Route>

          <Route path='sorting' component={WorkTrackerDetailsContainer}>
            <IndexRoute component={WorkTrackerSortingContainer} />
          </Route>

          <Route path='areas/:areaId' name='Area' staticName>
            <IndexRoute component={WorkTrackerAreaDetailsContainer} />
          </Route>
        </Route>
      </Route>

      <Route path='location-issues' name='Issues'>
        <IndexRoute component={LocationListContainer} />

        <Route path=':locationId' name='Index' staticName>
          <IndexRoute component={LocationIssuesListContainer} />

          <Route path='create' name='Create' staticName>
            <IndexRoute component={IssueCreateContainer} />
          </Route>

          <Route path='issue/:issueId' name='Issue' staticName>
            <IndexRoute component={IssueDetailsContainer} />

            <Route path='edit' name='edit' staticName>
              <IndexRoute component={IssueEditContainer} />
            </Route>

            <Route path='send_to_work_order' name='Work Order' staticName>
              <IndexRoute component={IssueWorkOrderFormContainer} />
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path='quality-assurance' name='Quality Assurance'>
        <IndexRoute component={QAWorkOrdersContainer} />

        <Route path='create' component={QAWorkOrdersContainer} name='createQAWorkOrder'>
          <IndexRoute component={QAWorkOrderCreateContainer} />
        </Route>

        <Route path=':qaWorkOrderId' name='Details' staticName>
          <IndexRoute component={QAWorkOrderDetailsContainer} />

          <Route path='areas' name='qaServicingWrapper'>
            <Route path='create' component={QAWorkOrderDetailsContainer} name='createQAServicing'>
              <IndexRoute component={QAServicingMultiCreateContainer} />
            </Route>

            <Route path=':qaServicingId' staticName name='Area' component={QAServicingDetailsContainer} />
          </Route>
        </Route>
      </Route>

      <Route path='inspections' name='Inspections List'>
        <IndexRoute component={InspectionLocationListContainer} />

        <Route path=':locationId' getDisplayName={({locationId}) => {
          const { locations: { [locationId]: { name = '' } = {} } = {} } = store.getState()
          return name
        }} >
          <IndexRoute component={LocationInspectionsListContainer} />

        </Route>
        <Route path=":inspectionId/images" name="Images">
          <IndexRoute component={InspectionImagesContainer} />
        </Route>
      </Route>

      <Route path='msds-sheets' component={MSDSSheetsContainer} name='MSDS Sheets' />

      <Route path='settings' component={SettingsContainer} name='Settings' />
    </Route>
    <Route path='*' component={NotFound} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js